export const HAPTIC_PATTERNS = Object.freeze({
  tap: Object.freeze([9]),
  selection: Object.freeze([7, 18, 7]),
  navigation: Object.freeze([11, 22, 8]),
  slider: Object.freeze([4]),
  submit: Object.freeze([13, 24, 9]),
  create: Object.freeze([12, 20, 12, 20, 18]),
  success: Object.freeze([10, 24, 22]),
  complete: Object.freeze([15, 24, 15, 24, 30]),
  water: Object.freeze([6, 14, 9, 16, 14]),
  close: Object.freeze([13, 28, 8]),
  clear: Object.freeze([18, 20, 9, 18, 8]),
  warning: Object.freeze([24, 34, 24]),
  error: Object.freeze([32, 38, 32, 38, 45]),
});

export const HAPTIC_STYLES = Object.freeze({
  tap: 'light',
  selection: 'selection',
  navigation: 'light',
  slider: 'selection',
  submit: 'medium',
  create: 'medium',
  success: 'success',
  complete: 'success',
  water: 'soft',
  close: 'light',
  clear: 'medium',
  warning: 'warning',
  error: 'error',
});

export const HAPTIC_KINDS = Object.freeze(Object.keys(HAPTIC_PATTERNS));

function explicitKind(value) {
  const kind = String(value || '').trim().toLowerCase();
  return HAPTIC_KINDS.includes(kind) ? kind : null;
}

export function classifyInteraction(input = {}) {
  if (input.disabled || input.dataHaptic === 'none') return null;
  const explicit = explicitKind(input.dataHaptic);
  if (explicit) return explicit;

  const tag = String(input.tagName || '').toLowerCase();
  const role = String(input.role || '').toLowerCase();
  const type = String(input.inputType || input.type || '').toLowerCase();
  const copy = `${input.text || ''} ${input.ariaLabel || ''} ${input.title || ''}`.trim().toLowerCase();

  if (type === 'range') return 'slider';
  if (tag === 'select' || role === 'switch' || ['checkbox', 'radio'].includes(type)) return 'selection';
  if (tag === 'input' || tag === 'textarea') return null;
  if (/\b(clear|clear all|dismiss all)\b/.test(copy)) return 'clear';
  if (/\b(delete|remove|discard|revoke)\b/.test(copy)) return 'warning';
  if (/\b(close|cancel|dismiss|sign out|log out|logout)\b/.test(copy)) return 'close';
  if (/\b(mark (?:task )?(?:as )?done|complete(?: task)?|finish(?: task)?)\b/.test(copy)) return 'complete';
  if (/\b(add water|log water|water|250 ml|500 ml|250ml|500ml)\b/.test(copy)) return 'water';
  if (/\b(create|new|add|invite|upload)\b/.test(copy)) return 'create';
  if (/\b(save|submit|send|approve|confirm|apply|update|check in|check out)\b/.test(copy) || type === 'submit') return 'submit';
  if (tag === 'a' || role === 'tab' || input.href) return 'navigation';
  if (tag === 'button' || role === 'button') return 'tap';
  return null;
}

function parseBody(body) {
  if (!body) return {};
  if (typeof body === 'object' && !(body instanceof String)) return body;
  try { return JSON.parse(String(body)); } catch { return {}; }
}

export function classifyMutation(input = {}) {
  const method = String(input.method || 'GET').toUpperCase();
  if (['GET', 'HEAD', 'OPTIONS'].includes(method)) return null;
  if (input.ok === false) return 'error';

  const path = String(input.path || '').split('?')[0].toLowerCase();
  const body = parseBody(input.body);
  if (/\/wellness\/hydration$/.test(path)) return 'water';
  if (/\/notifications\/clear$/.test(path)) return 'clear';
  if (/\/(?:auth\/)?logout$/.test(path)) return 'close';
  if (method === 'PATCH' && /\/tasks\/[^/]+$/.test(path) && String(body.status || '').toLowerCase() === 'done') return 'complete';
  if (method === 'POST' && /\/tasks$/.test(path)) return 'create';
  if (method === 'DELETE') return 'warning';
  if (method === 'POST' && /\/(?:projects|companies|departments|users|clients|invitations|leave|expenses|habits)$/.test(path)) return 'create';
  return 'success';
}
